import React, { useEffect, useState } from 'react'
import { CustomCard, Tooltip } from '@digicert/dcone-common-ui'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faPencil} from '@fortawesome/pro-light-svg-icons'
import { translate } from '../../../../shared/helpers/utils'
import { Translate } from 'react-localize-redux'
import styles from './LicenseCard.module.scss'
import {EditButtonRoleTypes, LicenseCardProps} from './LicenseCard.types'
import cn from 'classnames'
import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { RouterConfig } from "../../../../core/utils/constants";
import { DEVICE_TRUST_MANAGER } from "../../../../core/constants";
import { Link } from 'react-router-dom'
import { Applications, IlicenseCard } from '../Tenant.types'
import { AccountTypes } from 'secure-pages/tenants/Tenants.types'
import { LicenseFeatureVersion } from '../license-form/LicenseForm.types'

export const LicenseCard = (
  {
    data,
    canEdit,
    id,
    onEditClick,
    title,
    editButtonRole,
    accountId,
    applicationId,
    enablePackaging,
    licenseFeatureVersion,
    accountType
  }: LicenseCardProps) => {

  const getApplication = () => {
    return title?.split('-')[0].trim().replace(/\s+/g, '-').toLowerCase()
  }

  const [licenseTypes, setLicenseTypes] = useState<IlicenseCard[]>(data)

    useEffect(() => {
    if (licenseFeatureVersion) {
      // For STM (SSM) v2 accounts also surface the v2.5 derived seats
      // (repositories, test_signatures) alongside the v2 rows, mirroring the
      // edit-form behaviour so the summary card shows all attributes like v1.
      const isStm = id?.includes(Applications.SSM)
      const isTlm = id?.includes(Applications.MPKI)
      const licenseTypesState = data.filter((item) =>
        item.version === licenseFeatureVersion ||
        (isStm && licenseFeatureVersion === LicenseFeatureVersion.V2 && item.version === LicenseFeatureVersion.V2_5) ||
        // For TLM, domains (v2.6) is shown under license feature version v2 in BOTH toggle
        // states (v2 tlm_seat and v2.5 users/sites), mirroring the edit-form behaviour.
        (isTlm && item.version === LicenseFeatureVersion.V2_6 &&
          (licenseFeatureVersion === LicenseFeatureVersion.V2 || licenseFeatureVersion === LicenseFeatureVersion.V2_5))
      )
      setLicenseTypes(licenseTypesState)
    }
  }, [data, licenseFeatureVersion, id])

  const enableLink = accountType !== AccountTypes.PARTNER && ((id?.includes(Applications.MPKI) && enablePackaging?.tlmPackage) || (id?.includes(Applications.SSM) && enablePackaging?.stmPackage) || (id?.includes(Applications.AITM) && enablePackaging?.aitmPackage) || (id?.includes(Applications.QC) && enablePackaging?.qcPackage))

  return (
    <CustomCard>
      <div className={styles.card}>
        <div className={styles.cardHeader}>
          <div className={styles.label}>
            {enableLink ?
              <Link to={RouterConfig.accounts.packageFeatures(accountId, getApplication(), applicationId)}>{title}</Link> : title
            }
            {title === DEVICE_TRUST_MANAGER &&
              <a href={RouterConfig.urlMap.dtmLicensingAndPlans} className={styles.learnMore} target='_blank' rel='noopener noreferrer'>
                <Translate id='dashboardLicense.devicePlansLeanMore' />
              </a>
            }
          </div>

          <div className={styles.action}>
            <button
              aria-label={translate('common.edit') as string + ' ' + title}
              role={editButtonRole ? editButtonRole : EditButtonRoleTypes.BUTTON}
              onClick={() => { onEditClick(id, licenseTypes) }}
              className={cn(
                {
                  [styles.cantEditLicenseBtn]: !canEdit,
                  [styles.editLicenseBtn]: canEdit,
                }
              )}
            >
              <Tooltip placement='top' title={translate('profile.editBtn') + ' ' + title}>
                <FontAwesomeIcon size='lg' icon={faPencil as IconProp}/>
              </Tooltip>
            </button>
          </div>
        </div>
        <div className={styles.cardContentRowHeader}>
          <p><Translate id='common.form.licenseType'/></p>
          <p><Translate id='common.form.Remaining'/></p>
          <p><Translate id='common.form.totalAllocated'/></p>
        </div>
        {licenseTypes.map((item, index) => {
          return (
            <div key={index} className={styles.cardContentRow}>
              <p>{item.licenseType}</p>
              <p>{item.remaining}</p>
              <p>{item.totalAllocated}</p>
            </div>
          )
        })}
      </div>
    </CustomCard>
  )
}